/* assets/wofp-feed.js
   Lifted VERBATIM out of the Fresh Rx feeding section 2026-09-04 to get that
   section back under Shopify's 50 KB Custom Liquid cap. NOT ONE CHARACTER OF THE
   LOGIC CHANGED.

   IT MUST STAY A PLAIN <script src>, NOT defer AND NOT async. It is a bare IIFE
   that runs at parse time and needs wynfeed.js already loaded and the
   #wofpp-boot JSON already in the DOM. Plain external scripts run in document
   order, which is what preserves that. defer would break it.

   It reads every setting from #wofpp-boot, so it holds no Liquid and no per-diet
   values. That is why it can live out here at all.
*/
(function () {
'use strict';
var root = document.getElementById('wofp-feed');
if (!root) return;
if (!window.wynFeed) {
if (window.console) console.error('[#wofp-feed] wynfeed.js is not loaded. The shared feeding math is missing, so this section cannot calculate.');
return;
}
if (document.querySelectorAll('#wofp-feed').length > 1) {
if (window.console) console.error('[#wofp-feed] Duplicate section on page. Delete the older Custom Liquid block.');
}
var bootEl = document.getElementById('wofpp-boot');
var boot;
try { boot = JSON.parse(bootEl.textContent); }
catch (e) { if (window.console) console.error('wofpp: bad config JSON.', e); return; }
if (!boot || !boot.kcalCup) return;

var $ = function (id) { return document.getElementById(id); };
var OZ = 28.349523125;
var STORE = 'wyn_dog';
var FR = [0, ['1', '8', 'an eighth'], ['1', '4', 'a quarter'], ['3', '8', 'three eighths'], ['1', '2', 'a half'], ['5', '8', 'five eighths'], ['3', '4', 'three quarters'], ['7', '8', 'seven eighths']];
var GRP = String(boot.groups || '').split(',').map(function (s) {
var f = String(s).split('|');
return { p: parseFloat(f[0]) || 0, a: parseInt(f[1], 10) || 1, b: parseInt(f[2], 10) || 0 };
});
var PREVKEY = 'wyn_prev';
var prev = 0, setLo = 0, setHi = 0, setName = '';
var exactOn = String(boot.exact || '') === 'on';
var SIZES = String(boot.sizes || '').split(',').map(function (v) { return parseFloat(v) || 0; });
var VOLS = String(boot.vols || '').split(',').map(function (v) { return parseFloat(v) || 0; });
var NAMES = String(boot.names || '').split(',').map(function (v) { return String(v).trim(); });
var pkI = SIZES.length - 1;
var OVERNOTE = String(boot.overNote || '');
var OVERHOW = String(boot.overHow || '');
var PORNOTE = { 50: String(boot.porHalf || ''), 25: String(boot.porTop || '') };
var PORWORD = { 50: String(boot.porW50 || ''), 25: String(boot.porW25 || '') };
/* Empty honours anything. ***THE STORED VALUE IS NEVER REWRITTEN***, so a topper
   chosen on a Complete page survives being read as All of it here. */
var PORALLOW = String(boot.porAllow || '').split(',')
.map(function (v) { return parseFloat(v); })
.filter(function (v) { return v > 0 && v <= 100; });
var roomAuto = 1;
var REF = [];
String(boot.refs || '').split(',').forEach(function (s) {
var f = String(s).split('|');
if (parseFloat(f[0]) > 0 && f[1]) REF.push({ v: parseFloat(f[0]), s: f[1], p: f[2] || f[1] });
});

var WORDS = String(boot.words || '').split(',');
function numW(n) {
n = Math.round(n);
return (n >= 1 && n <= WORDS.length && WORDS[n - 1]) ? WORDS[n - 1] : String(n);
}

var WSTART = Math.round(parseFloat(boot.wtStart));
if (!(WSTART >= 1 && WSTART <= 250)) WSTART = 40;

function readDog() {
var d = { weight_lb: WSTART, age: '1', activity: '1.55', portion: 100, known: false };
try {
var raw = localStorage.getItem(STORE);
if (!raw) return d;
var s = JSON.parse(raw);
if (!s) return d;
/* OUTSIDE THE WEIGHT GATE ON PURPOSE - a share with no weight still applies. */
if (s.portion > 0 && s.portion <= 100) d.portion = Math.round(s.portion);
if (typeof s.weight_lb === 'number' && s.weight_lb >= 1 && s.weight_lb <= 250) {
d.weight_lb = Math.round(s.weight_lb);
if (s.age) d.age = String(s.age);
if (s.activity) d.activity = String(s.activity);
if (s.updated > 0) d.updated = s.updated;
d.known = true;
}
} catch (e) {}
return d;
}
var dog = readDog();
var saveTimer = null;
var stamp = 0;
function saveDog(broadcast) {
stamp = Date.now();
if (saveTimer) clearTimeout(saveTimer);
saveTimer = setTimeout(function () {
try { localStorage.setItem(STORE, JSON.stringify({ weight_lb: dog.weight_lb, age: dog.age, activity: dog.activity, portion: dog.portion, updated: Date.now() })); } catch (e) {}
}, 400);
if (broadcast) {
try { document.dispatchEvent(new CustomEvent('wyn:dog', { detail: { weight_lb: dog.weight_lb, age: dog.age, activity: dog.activity, portion: dog.portion }, bubbles: true })); } catch (e) {}
}
}

function num(v, f) { var n = parseFloat(v); return n > 0 ? n : f; }
var WMIN = num(boot.wtMin, 3), WMAX = num(boot.wtMax, 130), WMID = num(boot.wtMid, 40);
var WK = Math.log((WMID - WMIN) / (WMAX - WMIN)) / Math.log(0.5);
if (!(WK > 0) || !isFinite(WK)) WK = 1;
var WSNAP = num(boot.wtSnap, 0);
function wtStep(w) { return (WSNAP > 0 && w >= WSNAP) ? 5 : 1; }
function snapWt(w) {
if (WSNAP > 0 && w >= WSNAP - 2.5) return Math.min(WMAX, Math.round(w / 5) * 5);
return Math.round(w);
}
function posToWt(p) { return snapWt(WMIN + (WMAX - WMIN) * Math.pow(p / 1000, WK)); }
function wtToPos(w) {
var t = (Math.min(WMAX, Math.max(WMIN, w)) - WMIN) / (WMAX - WMIN);
return Math.round(1000 * Math.pow(t, 1 / WK));
}
function porPct() {
var p = parseFloat(dog.portion);
if (!(p > 0 && p <= 100)) return 100;
if (PORALLOW.length && PORALLOW.indexOf(p) === -1) return 100;
return p;
}
/* ONE COPY OF THE MATH. The diet key is passed so a therapeutic reduction lands,
   and it is ***`kcal`, NOT `kcalFull`*** - kcalFull is before the diet factor.
   boot.fresh IS INERT; the library owns the 0.8. */
function planNow() {
return window.wynFeed.plan({
weight_lb: dog.weight_lb,
activity: num(dog.activity, 1.55),
ageFactor: num(dog.age, 1)
}, { key: boot.dietKey }, {});
}
function merFull() { return planNow().kcal * num(boot.cm, 1); }
function mer() { return merFull() * porPct() / 100; }
function cupsDay() { return mer() / boot.kcalCup; }
function gramsDay() { return mer() / boot.kcalKg * 1000; }
function c1(n) { return (Math.round(n * 10) / 10).toFixed(1); }
function refOf(v) {
var i, r = REF[0], n;
for (i = 1; i < REF.length; i++) { if (v / REF[i].v >= 0.75) r = REF[i]; }
n = Math.round(v / r.v);
return n > 1 ? numW(n) + ' ' + r.p : r.s;
}
function fracHtml(r, w) {
var f = FR[r];
return '<span class="wofpp-frac" aria-hidden="true"><span class="wofpp-frac__n">' + f[0] +
'</span><span class="wofpp-frac__d">' + f[1] + '</span></span><span class="wofpp-sr">' +
(w ? ' and ' : ' ') + f[2] + '</span>';
}
function fmtFrac(n, d) {
var q = Math.round(n * d);
var w = Math.floor(q / d);
var r = (q - w * d) * (8 / d);
if (!(w > 0)) return r ? fracHtml(r, 0) : '0';
return String(w) + (r ? fracHtml(r, 1) : '');
}
function ozFrac(n) { return fmtFrac(n, 4); }
function fmtSpan(d) {
if (!(d > 0)) return '';
if (d < 0.25) return 'less than half a day';
var pre = 'about ';
if (d >= 10) return pre + numW(Math.round(d)) + ' days';
var h = Math.round(d * 2) / 2, w = Math.floor(h), half = h - w > 0;
if (!(w > 0)) return pre + 'half a day';
return pre + numW(w) + (half ? ' and a half' : '') + (h <= 1 ? ' day' : ' days');
}
function fill(str, map) { return String(str).replace(/\{(\w+)\}/g, function (m, k) { return map[k] == null ? '' : map[k]; }); }
function isRange() { return setLo > 0 && setHi > setLo; }
function prevOdd() { return !isRange() && (prev < boot.prevLo || prev > boot.prevHi); }
function oursG(pct) { return gramsDay() * pct / 100; }
/* ***THE WHOLE DAY MINUS WHAT WE SUPPLY***, not a share of our share. */
function theirG(kk, pct) { return kk > 0 ? (merFull() - mer() * pct / 100) / kk * 1000 : 0; }
function restPct(pct) { return Math.round(100 - porPct() * pct / 100); }
function ozDial(n) { return n < 1 ? c1(n) : ozFrac(n); }
function ozTxt(n) { return String(Math.round(n * 4) / 4); }
function theirFrac(pct) {
return (isRange() ? '\u2248 ' : '') + ozDial(theirG(prev, pct) / OZ);
}
function thou(v) { return String(Math.round(v)).replace(/\B(?=(\d{3})+$)/g, ','); }
function actWord() {
var a = parseFloat(dog.activity);
if (a === 1.2) return 'low activity';
if (a === 1.75) return 'high activity';
return 'normal activity';
}
function ageWord() {
var a = parseFloat(dog.age);
if (a > 1) return 'puppy';
if (a === 0.9) return 'senior';
return 'adult';
}

function renderWho() {
$('wofpp-who-k').textContent = dog.known ? 'Your plan' : 'Sample plan';
$('wofpp-who-v').textContent = dog.weight_lb + ' lb ' + ageWord();
$('wofpp-who-a').textContent = actWord();
}

function renderDay() {
var c = cupsDay();
var g = gramsDay();
$('wofpp-oz').innerHTML = ozFrac(g / OZ);
$('wofpp-cups').innerHTML = fmtFrac(c, c < 1 ? 8 : 4);
$('wofpp-kc').textContent = Math.round(mer());
}

/* The share note is silent at 100 percent, and the step and pip labels are
   rewritten to "25% of your half" or they would LIE. The reduction is stated,
   never swallowed, and is absent on the eight diets fed at maintenance. */
function renderRed() {
var el = $('wofpp-red');
if (!el) return;
var r = planNow().reduction;
var s = (r > 0 && boot.redNote) ? String(boot.redNote).replace('{n}', Math.round(r)) : '';
el.textContent = s;
el.hidden = !s;
}

function renderPor() {
var el = $('wofpp-por');
var t = PORNOTE[porPct()] || '';
if (el) { el.textContent = t; el.hidden = !t; }
var w = PORWORD[porPct()] || '';
var st = root.querySelectorAll('.wofpp-step'), mp = root.querySelectorAll('.wofpp-map__i'), i, e;
for (i = 0; i < st.length && i < GRP.length; i++) {
e = st[i].querySelector('.wofpp-step__p');
if (e) e.textContent = w ? GRP[i].p + '% of ' + w : GRP[i].p + '% Wynwood';
}
for (i = 0; i < mp.length && i < GRP.length; i++) {
e = mp[i].querySelector('.wofpp-map__p');
if (e) e.textContent = w ? GRP[i].p + '% of ' + w : GRP[i].p + '% Wynwood';
}
}

function renderSpace() {
var el = $('wofpp-space');
if (!el) return;
var i = (pkI >= 0 && pkI < SIZES.length) ? pkI : SIZES.length - 1;
var big = SIZES[i] || 64;
var vol = VOLS[i] || 0;
var days = big * OZ / gramsDay();
var two = Math.ceil(14 / days);
var thaw = num(boot.thaw, 0);
var over = thaw > 0 && days > thaw;
var txt = 'For your dog, one ' + pkName(i) + ' packet lasts <b' + (over ? ' class="is-over"' : '') +
'>' + fmtSpan(days) + '</b>.' + (over && OVERNOTE ? ' ' + OVERNOTE : '') +
' A two-week supply is roughly <b>' + numW(two) + ' ' + (two === 1 ? 'packet' : 'packets') + '</b>';
if (vol > 0 && REF.length) {
txt += ' and takes up about as much freezer space as <b>' + refOf(two * vol) + '</b>';
}
txt += '.';
el.innerHTML = txt;
cueOver(over, thaw);
}

function cueOver(over, thaw) {
var how = $('wofpp-how'), dot = $('wofpp-dot'), room, s;
s = (over && OVERHOW) ? fill(OVERHOW, { n: numW(thaw) }) : '';
if (how) { how.innerHTML = s; how.hidden = !s; }
if (dot) dot.hidden = !s;
if (over && roomAuto && s && tmq && tmq.matches) {
room = $('wofpp-tile-room');
if (room) room.open = true;
}
}

function pkName(i) { return NAMES[i] || (SIZES[i] ? SIZES[i] + ' oz' : 'this'); }

function pkBox(r) {
var n = r, i;
for (i = 0; i < 5 && n && n.parentNode; i++) {
n = n.parentNode;
if (n.nodeType !== 1) break;
if (n.tagName === 'LABEL' || String(n.className || '').indexOf('wofp-opt') > -1) return n;
}
return null;
}

function pkByOz(str) {
var m = String(str || '').match(/(\d+(?:\.\d+)?)\s*oz\b/i), i;
if (m) { for (i = 0; i < SIZES.length; i++) { if (SIZES[i] === parseFloat(m[1])) return i; } }
return -1;
}

function pkByName(str) {
var s = String(str || '').toLowerCase(), i, n;
for (i = 0; i < SIZES.length; i++) {
n = String(NAMES[i] || '').toLowerCase();
if (n && s.indexOf(n) > -1) return i;
}
return -1;
}

function pkOf(r) {
var box = pkBox(r), oz = parseFloat(r.getAttribute('data-oz')), e, j, s;
if (oz > 0) { for (j = 0; j < SIZES.length; j++) { if (SIZES[j] === oz) return j; } }
j = pkByOz(box ? box.textContent : r.value);
if (j > -1) return j;
s = ' ' + (r.value || '') + ' ' + (r.getAttribute('aria-label') || '');
if (r.id) { e = document.querySelector('label[for="' + r.id + '"]'); if (e) s += ' ' + (e.textContent || ''); }
if (box) { e = box.querySelector('.wofp-opt__name'); s += ' ' + (e ? (e.textContent || '') : (box.getAttribute('data-size') || '')); }
return pkByName(s);
}

/* WHICH SIZE CARD IS CHECKED, FOUR RUNGS DOWN: data-oz, an ounce figure in the
   card, the size NAME on tight text only, then position among .wofp-opt radios.
   ***THE OUNCE RUNG ALONE WAS THE OLD BUG*** - the cards say Small and Large. */
function pkFind() {
var host = document.getElementById('wofpb');
if (!host) return -1;
var rs = host.querySelectorAll('.wofp-opt input[type="radio"]');
var scoped = rs.length > 0, i, j;
if (!scoped) rs = host.querySelectorAll('input[type="radio"]');
for (i = 0; i < rs.length; i++) {
if (!rs[i].checked) continue;
j = pkOf(rs[i]);
if (j < 0 && scoped && rs.length === SIZES.length) j = i;
if (j > -1) return j;
}
return -1;
}

function pkTake(i) {
if (i < 0 || i >= SIZES.length || i === pkI) return;
pkI = i;
try { renderSpace(); } catch (e) {}
}

function pkSync() { pkTake(pkFind()); }

function wirePack() {
if (SIZES.length < 2) return;
document.addEventListener('change', pkSync, true);
document.addEventListener('wyn:size', function (e) {
var d = e && e.detail, j, s;
if (!d) return;
s = String(d.size || d.title || d.label || d.name || d.variant || '');
j = pkByOz(' ' + d.oz + ' oz ');
if (j < 0) j = pkByOz(s);
if (j < 0) j = pkByName(s);
if (j > -1) pkTake(j);
});
window.addEventListener('pageshow', pkSync);
/* A late click resync, for a size the buy box changes without a change event
   (a duration preset, say). pkSync is a no-op unless the index moved. */
document.addEventListener('click', function () { setTimeout(pkSync, 0); });
pkSync();
setTimeout(pkSync, 600);
setTimeout(pkSync, 2000);
}

var PEEK = num(boot.peekPct, 100) * 3.6;
var dialI = 0, dialA = PEEK, dialRAF = 0, dialOn = 0;

function dialTarget() {
if (trFolded) return PEEK;
return GRP.length ? GRP[dialI].p * 3.6 : 0;
}

function paintDial(a) {
var d = $('wofpp-dial'), s = $('wofpp-seam');
dialA = a;
if (d) { d.style.setProperty('--a', a + 'deg'); d.setAttribute('data-full', a >= 359.5 ? '1' : '0'); }
if (s) s.style.setProperty('--s', (180 + a) + 'deg');
}

function tweenDial(to) {
if (dialRAF) { cancelAnimationFrame(dialRAF); dialRAF = 0; }
if (stillMotion() || !window.requestAnimationFrame) { paintDial(to); return; }
var from = dialA, t0 = 0;
dialRAF = requestAnimationFrame(function step(now) {
if (!t0) t0 = now;
var k = (now - t0) / 520;
if (k > 1) k = 1;
paintDial(from + (to - from) * (1 - Math.pow(1 - k, 3)));
if (k < 1) { dialRAF = requestAnimationFrame(step); } else { dialRAF = 0; }
});
}

function stillMotion() {
try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
catch (e) { return false; }
}

function renderRamp() {
var steps = $('wofpp-steps');
if (!steps || !GRP.length) { renderSwapNote(); return; }
if (dialI >= GRP.length) dialI = 0;
var g = GRP[dialI], rest = restPct(g.p), swap = prev > 0, i, b;
for (i = 0; i < steps.children.length; i++) {
b = steps.children[i];
b.setAttribute('aria-checked', i === dialI ? 'true' : 'false');
b.tabIndex = i === dialI ? 0 : -1;
}
b = steps.children[dialI];
$('wofpp-rd-d').textContent = b ? b.querySelector('.wofpp-step__d').textContent : '';
var ours = ozDial(oursG(g.p) / OZ);
var tv = $('wofpp-rd-t'), tu = $('wofpp-rd-tu'), val, unit;
if (rest <= 0) { val = 'None'; unit = ''; }
else if (swap) { val = theirFrac(g.p); unit = 'oz'; }
else { val = rest + '%'; unit = 'of their usual'; }
$('wofpp-rd-o').innerHTML = ours;
tv.innerHTML = val;
tu.hidden = !unit;
tu.textContent = unit;
(dialOn ? tweenDial : paintDial)(dialTarget());
renderSwapNote();
}

function goDial(i) {
if (i < 0 || i >= GRP.length) return;
dialI = i;
renderRamp();
}

function wireDial() {
var steps = $('wofpp-steps');
if (!steps) return;
var kids = steps.children, L = kids.length, i;
for (i = 0; i < L; i++) {
(function (n, el) {
el.addEventListener('click', function () { goDial(n); });
el.addEventListener('keydown', function (e) {
var t = -1;
if (e.key === 'ArrowRight' || e.key === 'ArrowDown') t = (n + 1) % L;
if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') t = (n + L - 1) % L;
if (t < 0) return;
e.preventDefault();
goDial(t);
kids[t].focus();
});
})(i, kids[i]);
}
dialOn = 1;
var target = dialTarget();
if (stillMotion() || !window.IntersectionObserver || trFolded) { paintDial(target); return; }
var d = $('wofpp-dial');
if (!d || d.getBoundingClientRect().top < window.innerHeight * 0.8) { paintDial(target); return; }
var fired = false;
var io = new IntersectionObserver(function (en) {
var k;
for (k = 0; k < en.length; k++) {
if (en[k].isIntersecting && !fired) { fired = true; tweenDial(target); io.disconnect(); }
}
}, { threshold: 0.35 });
paintDial(0);
io.observe(d);
setTimeout(function () { if (!fired) { fired = true; paintDial(target); } }, 2600);
}

function renderSwapNote() {
var el = $('wofpp-swap-note');
var clr = $('wofpp-prev-clr');
var ap = $('wofpp-approx');
var ex = $('wofpp-exact');
if (prev > 0) exactOn = true;
if (ex) ex.hidden = !exactOn;
if (clr) clr.hidden = !(prev > 0);
if (ap) ap.hidden = !isRange();
if (!el) return;
if (!(prev > 0)) { el.textContent = ''; el.classList.remove('is-bad'); return; }
if (prevOdd()) {
el.textContent = boot.swapBad;
el.classList.add('is-bad');
return;
}
el.classList.remove('is-bad');
if (isRange()) {
el.innerHTML = fill(boot.swapEst, { label: setName, lo: thou(setLo), hi: thou(setHi) });
return;
}
var sp = (GRP.length && dialI < GRP.length) ? GRP[dialI].p : 100;
el.innerHTML = fill(boot.swapWhy, {
kc: Math.round(merFull()),
a: ozTxt(oursG(sp) / OZ),
b: ozTxt(theirG(prev, sp) / OZ)
});
}

function markSets() {
var bs = root.querySelectorAll('.wofpp-swap__set');
for (var i = 0; i < bs.length; i++) {
var on = isRange() && parseFloat(bs[i].getAttribute('data-lo')) === setLo &&
parseFloat(bs[i].getAttribute('data-hi')) === setHi;
bs[i].classList.toggle('is-on', on);
bs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
}
renderPick();
}

function renderPick() {
var el = $('wofpp-swap-pick'), u;
if (!el) return;
if (setName) { el.textContent = setName; return; }
u = root.querySelector('.wofpp-swap__u');
el.textContent = prev > 0 ? thou(prev) + (u ? ' ' + u.textContent : '') : '';
}

function applyPrev() {
try {
if (prev > 0) {
localStorage.setItem(PREVKEY, JSON.stringify(isRange() ?
{ k: prev, lo: setLo, hi: setHi, n: setName } : { k: prev }));
} else localStorage.removeItem(PREVKEY);
} catch (e) {}
markSets();
try { renderRamp(); } catch (e) {}
}

function prevSet(v) {
var p = parseFloat(v);
setLo = 0; setHi = 0; setName = '';
prev = p > 0 ? p : 0;
applyPrev();
}

function setPick(lo, hi, name) {
setLo = lo; setHi = hi; setName = name;
prev = (lo + hi) / 2;
var f = $('wofpp-prev');
if (f) f.value = Math.round(prev);
applyPrev();
}

function renderAll() {
try { renderWho(); } catch (e) {}
try { renderDay(); } catch (e) {}
try { renderPor(); } catch (e) {}
try { renderRed(); } catch (e) {}
try { renderSpace(); } catch (e) {}
try { renderRamp(); } catch (e) {}
}

var wtEl = $('wofpp-wt');
var slideEl = $('wofpp-slide');
function wtSet(n, from) {
roomAuto = 0;
n = Math.round(n);
if (!(n >= 1)) n = 1;
if (n > 250) n = 250;
dog.weight_lb = n;
dog.known = true;
if (wtEl && from !== 'input') wtEl.value = n;
if (slideEl && from !== 'slide') slideEl.value = wtToPos(n);
if (slideEl) slideEl.setAttribute('aria-valuetext', n + ' lb');
saveDog(true);
renderAll();
}
if (slideEl) {
slideEl.addEventListener('input', function () { wtSet(posToWt(parseFloat(slideEl.value)), 'slide'); });
slideEl.addEventListener('keydown', function (ev) {
var d = 0, k = ev.key;
if (k === 'ArrowLeft' || k === 'ArrowDown') d = -wtStep(dog.weight_lb);
else if (k === 'ArrowRight' || k === 'ArrowUp') d = wtStep(dog.weight_lb);
else if (k === 'PageDown') d = -10;
else if (k === 'PageUp') d = 10;
if (!d) return;
ev.preventDefault();
wtSet(dog.weight_lb + d);
});
}
if (wtEl) {
wtEl.addEventListener('focus', function () { wtEl.select(); });
wtEl.addEventListener('input', function () {
var n = parseFloat(wtEl.value);
if (!isNaN(n) && n >= 1) wtSet(n, 'input');
});
wtEl.addEventListener('blur', function () { wtEl.value = dog.weight_lb; });
}
var blankEl = $('wofpp-blank');
if (blankEl && wtEl) {
blankEl.addEventListener('mousedown', function (ev) {
if (ev.target !== wtEl) { ev.preventDefault(); wtEl.focus(); }
});
}
var steps = root.querySelectorAll('.wofpp-wt__step');
for (var s = 0; s < steps.length; s++) {
(function (b) {
b.addEventListener('click', function () { wtSet(dog.weight_lb + (parseInt(b.getAttribute('data-wt'), 10) || 0)); });
})(steps[s]);
}

var goEl = $('wofpp-who-go');
if (goEl) {
var goTarget = null;
try { goTarget = document.querySelector(boot.topSel); } catch (e) {}
if (!goTarget) goTarget = document.getElementById('wofp-form') || document.querySelector('#wofpb');
if (goTarget) {
goEl.hidden = false;
goEl.addEventListener('click', function () {
var soft = true, sum;
try { soft = !window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
if (goTarget.tagName === 'DETAILS') {
if (!goTarget.open) goTarget.open = true;
sum = goTarget.querySelector('summary');
if (sum) { try { sum.focus({ preventScroll: true }); } catch (e2) {} }
}
try { goTarget.scrollIntoView({ behavior: soft ? 'smooth' : 'auto', block: 'center' }); }
catch (e3) { try { goTarget.scrollIntoView(); } catch (e4) {} }
});
}
}

document.addEventListener('wyn:dog', function (e) {
var d = e && e.detail;
if (!d || typeof d.weight_lb !== 'number') return;
var dp = (d.portion > 0 && d.portion <= 100) ? Math.round(d.portion) : dog.portion;
if (d.weight_lb === dog.weight_lb && String(d.age) === dog.age && String(d.activity) === dog.activity && dp === dog.portion) return;
dog.weight_lb = Math.round(d.weight_lb);
if (d.age) dog.age = String(d.age);
if (d.activity) dog.activity = String(d.activity);
dog.portion = dp;
dog.known = true;
stamp = Date.now();
syncControls();
renderAll();
});
function syncControls() {
if (wtEl) wtEl.value = dog.weight_lb;
if (slideEl) {
slideEl.value = wtToPos(dog.weight_lb);
slideEl.setAttribute('aria-valuetext', dog.weight_lb + ' lb');
}
}
function repull() {
var fresh = readDog();
if (!fresh.known) return;
if (stamp && !(fresh.updated > stamp)) return;
if (fresh.weight_lb === dog.weight_lb && fresh.age === dog.age && fresh.activity === dog.activity && fresh.portion === dog.portion) return;
dog = fresh;
syncControls();
renderAll();
}
document.addEventListener('visibilitychange', function () { if (!document.hidden) repull(); });
window.addEventListener('pageshow', repull);

var prevEl = $('wofpp-prev');
var prevClr = $('wofpp-prev-clr');
var prevRaw = null;
try { prevRaw = localStorage.getItem(PREVKEY); } catch (e) {}
var prevObj = null;
if (prevRaw) {
try { prevObj = JSON.parse(prevRaw); } catch (e) { prevObj = { k: parseFloat(prevRaw) }; }
}
if (!prevObj || !(prevObj.k > 0)) {
var seed = parseFloat(boot.prevKcal) || 0;
prevObj = seed > 0 ? { k: seed } : null;
}
if (prevObj && prevObj.k > 0) {
prev = prevObj.k;
if (prevObj.lo > 0 && prevObj.hi > prevObj.lo) {
setLo = prevObj.lo; setHi = prevObj.hi; setName = prevObj.n || '';
}
if (prevEl) prevEl.value = Math.round(prevObj.k);
}
markSets();
var setBtns = root.querySelectorAll('.wofpp-swap__set');
for (var sb = 0; sb < setBtns.length; sb++) {
(function (b) {
b.addEventListener('click', function () {
var lo = parseFloat(b.getAttribute('data-lo')), hi = parseFloat(b.getAttribute('data-hi'));
if (!(lo > 0) || !(hi > lo)) return;
setPick(lo, hi, b.textContent);
});
})(setBtns[sb]);
}
if (prevEl) {
prevEl.addEventListener('focus', function () { prevEl.select(); });
prevEl.addEventListener('input', function () { prevSet(prevEl.value); });
}
if (prevClr) {
prevClr.addEventListener('click', function () {
if (prevEl) prevEl.value = '';
prevSet(0);
if (prevEl) prevEl.focus();
});
}

var tmq = null;
try { tmq = window.matchMedia('(max-width:700px)'); } catch (e) {}
function tset(o) { var t = root.querySelectorAll('.wofpp-tile,.wofpp-swap'), i; for (i = 0; i < t.length; i++) t[i].open = o; }
if (tmq && tmq.matches) tset(false);
root.addEventListener('toggle', function (e) { if (!(tmq && tmq.matches) && !e.target.open) e.target.open = true; }, true);
if (tmq && tmq.addEventListener) tmq.addEventListener('change', function (e) { if (!e.matches) tset(true); });

var trEl = $('wofpp-tr'), trFoldEl = $('wofpp-trfold'), trFolded = 0, trSeen = 0;
function setTrFold(on) {
if (!trEl || !trFoldEl) return;
trFolded = on ? 1 : 0;
trEl.classList.toggle('is-fold', !!on);
trFoldEl.setAttribute('aria-expanded', on ? 'false' : 'true');
}
function trSweep() {
if (trSeen) { tweenDial(dialTarget()); return; }
trSeen = 1;
paintDial(0);
tweenDial(dialTarget());
}
if (trEl && trFoldEl) {
setTrFold(1);
trFoldEl.addEventListener('click', function () { setTrFold(!trFolded); if (trFolded) tweenDial(dialTarget()); else trSweep(); });
var trgEl = root.querySelector('.wofpp-trg');
if (trgEl) trgEl.addEventListener('click', function () { if (trFolded) { setTrFold(0); trSweep(); } });
}

syncControls();
renderAll();
wireDial();
wirePack();

if (!(window.CSS && CSS.supports && CSS.supports('selector(:has(*))'))) {
var sec = root.closest('.shopify-section') || root.parentElement;
if (sec) {
sec.style.margin = '0'; sec.style.padding = '0';
var cont = sec.querySelector('.container');
if (cont) { cont.style.overflow = 'visible'; cont.style.maxWidth = 'none'; cont.style.width = '100%'; cont.style.padding = '0'; }
var pv = sec.previousElementSibling;
if (pv) { pv.style.marginBottom = '0'; pv.style.paddingBottom = '0'; }
}
}
})();